<header class="header">
  
  <p class="text-h5">パスワードの再設定</p>
</header>
<div class="container isBackgoround">
  <main>
    <div class="container_min v-application v-application--is-ltr theme--light">
      <form>
        <div class="text-center mb-10">
          <p style="text-align: left" class="v-text">
            下記に登録したメールアドレスを入力してください。パスワード再設定のご案内をメールでお送りします。
          </p>
        </div>
        <div
          class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
        >
          <div class="v-input__control">
            <div
              class="v-input__slot"
              [ngClass]="errorMessages.login.email ? ['custom-error'] : []"
            >
              <div class="v-text-field__slot">
                <label
                  for="input-13"
                  [ngClass]="inputLabelClass"
                  class="text-black-38"
                  style="left: 0px; right: auto; position: absolute"
                  >メールアドレス</label
                ><input
                  (focus)="focus(inputState.email)"
                  (blur)="blur(inputState.email)"
                  id="input-13"
                  name="input-13"
                  type="email"
                  [(ngModel)]="email"
                />
              </div>
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.forgetpassword.email"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.forgetpassword.email }}

                  <!-- 注釈及びエラーテキストが入ります。 -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mb-5">
          <button
            type="button"
            class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary primary-button"
            medium=""
            (click)="changePassword()"
          >
            <span class="v-btn__content bold"> 送信する </span>
          </button>
        </div>
      </form>
    </div>
  </main>
</div>
